/* SPY EYE — Shopify theme JS (header, nav, FAQ, testimonials, gallery, reveal) */

function initHeader(){
  const header = document.querySelector(".site-header");
  if(!header) return;
  const onScroll = () => header.classList.toggle("is-scrolled", window.scrollY > 40);
  onScroll();
  window.addEventListener("scroll", onScroll, { passive: true });

  const toggle = document.querySelector(".nav-toggle");
  const nav = document.querySelector(".main-nav");
  if(toggle && nav){
    toggle.addEventListener("click", () => {
      nav.classList.toggle("is-open");
      toggle.classList.toggle("is-open");
    });
    nav.querySelectorAll("a").forEach(a => a.addEventListener("click", () => nav.classList.remove("is-open")));
  }
}

function initFaq(){
  document.querySelectorAll(".faq-item").forEach(item => {
    const q = item.querySelector(".faq-q");
    const a = item.querySelector(".faq-a");
    if(!q || !a) return;
    q.addEventListener("click", () => {
      const isOpen = item.classList.contains("is-open");
      document.querySelectorAll(".faq-item").forEach(i => { i.classList.remove("is-open"); i.querySelector(".faq-a").style.maxHeight = null; });
      if(!isOpen){ item.classList.add("is-open"); a.style.maxHeight = a.scrollHeight + "px"; }
    });
  });
}

function initTestimonials(){
  const slides = document.querySelectorAll(".testi-slide");
  const dots = document.querySelectorAll(".testi-dots span");
  if(!slides.length) return;
  let idx = 0;
  const show = i => {
    slides.forEach((s,n) => s.classList.toggle("is-active", n===i));
    dots.forEach((d,n) => d.classList.toggle("is-active", n===i));
    idx = i;
  };
  document.querySelector(".testi-next")?.addEventListener("click", () => show((idx+1) % slides.length));
  document.querySelector(".testi-prev")?.addEventListener("click", () => show((idx-1+slides.length) % slides.length));
  dots.forEach((d,n) => d.addEventListener("click", () => show(n)));
  if(slides.length > 1) setInterval(() => show((idx+1) % slides.length), 6000);
}

function initGallery(){
  const main = document.getElementById("mainMediaImg");
  const thumbs = document.querySelectorAll(".gallery-thumb");
  if(!main || !thumbs.length) return;
  thumbs.forEach(t => t.addEventListener("click", () => {
    main.src = t.dataset.full;
    thumbs.forEach(x => x.classList.remove("is-active"));
    t.classList.add("is-active");
  }));
}

function observeReveals(){
  const els = document.querySelectorAll("[data-reveal]:not(.is-visible)");
  if(!("IntersectionObserver" in window)){ els.forEach(el => el.classList.add("is-visible")); return; }
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => { if(e.isIntersecting){ e.target.classList.add("is-visible"); io.unobserve(e.target); } });
  }, { threshold: .12 });
  els.forEach(el => io.observe(el));
}

document.addEventListener("DOMContentLoaded", () => {
  initHeader();
  initFaq();
  initTestimonials();
  initGallery();
  observeReveals();
});
